import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class ItemWebsiteService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

    getItems(maxItemsPerPage = 10, page=1){
        let url = 'get_items?page=' + page + '&maxItemsPerPage=' + maxItemsPerPage
        return this.http.get(this.BASE_URL_API_WEBSITE + url,this.storage.getHeaders())
    }

    getItemDropdown(){
      let url = 'public/get_item_dropdown';
      return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
      }


}
